import { createSlice } from '@reduxjs/toolkit'

export const SelectDropDownSlice = createSlice(
  {
  name: 'select_dropdown',
  initialState: {
    value: '',
  },
  reducers: {
    departmentSelected: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { departmentSelected } = SelectDropDownSlice.actions

export default SelectDropDownSlice.reducer